var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "v-dialog",
    {
      attrs: {
        value: _vm.visible,
        "max-width": "45rem",
        persistent: "",
        scrollable: "",
      },
      on: { input: _vm.close },
    },
    [
      _c(
        "v-card",
        { attrs: { loading: _vm.loading, disabled: _vm.loading } },
        [
          _c("v-card-title", [
            _vm._v(_vm._s(_vm.$t("pages.settings.users.editDialog.title"))),
          ]),
          _c("v-divider", { staticClass: "w-100" }),
          _c("validation-observer", {
            ref: "observer",
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function ({ invalid }) {
                  return [
                    _vm.user
                      ? _c(
                          "v-card-text",
                          { staticClass: "pt-5" },
                          [
                            _c("validation-provider", {
                              attrs: { name: "firstName", rules: "required" },
                              scopedSlots: _vm._u(
                                [
                                  {
                                    key: "default",
                                    fn: function ({ errors }) {
                                      return [
                                        _c("v-text-field", {
                                          staticClass: "mb-2",
                                          attrs: {
                                            outlined: "",
                                            "error-messages": errors,
                                            autocomplete: "off",
                                            name: "editUserFirstName",
                                            label: _vm.$t(
                                              "pages.settings.users.addDialog.firstName"
                                            ),
                                          },
                                          model: {
                                            value: _vm.form.firstName,
                                            callback: function ($$v) {
                                              _vm.$set(
                                                _vm.form,
                                                "firstName",
                                                $$v
                                              )
                                            },
                                            expression: "form.firstName",
                                          },
                                        }),
                                      ]
                                    },
                                  },
                                ],
                                null,
                                true
                              ),
                            }),
                            _c("validation-provider", {
                              attrs: { name: "lastName", rules: "required" },
                              scopedSlots: _vm._u(
                                [
                                  {
                                    key: "default",
                                    fn: function ({ errors }) {
                                      return [
                                        _c("v-text-field", {
                                          staticClass: "mb-4",
                                          attrs: {
                                            outlined: "",
                                            "error-messages": errors,
                                            autocomplete: "off",
                                            name: "editUserLastName",
                                            label: _vm.$t(
                                              "pages.settings.users.addDialog.lastName"
                                            ),
                                          },
                                          model: {
                                            value: _vm.form.lastName,
                                            callback: function ($$v) {
                                              _vm.$set(
                                                _vm.form,
                                                "lastName",
                                                $$v
                                              )
                                            },
                                            expression: "form.lastName",
                                          },
                                        }),
                                      ]
                                    },
                                  },
                                ],
                                null,
                                true
                              ),
                            }),
                            _c("v-text-field", {
                              staticClass: "mb-4",
                              attrs: {
                                value: _vm.user.email,
                                outlined: "",
                                disabled: "",
                                "hide-details": "",
                                label: _vm.$t(
                                  "pages.settings.users.addDialog.email"
                                ),
                              },
                              scopedSlots: _vm._u(
                                [
                                  {
                                    key: "append",
                                    fn: function () {
                                      return [
                                        _c(
                                          "v-tooltip",
                                          {
                                            attrs: { top: "" },
                                            scopedSlots: _vm._u(
                                              [
                                                {
                                                  key: "activator",
                                                  fn: function ({ on, attrs }) {
                                                    return [
                                                      _c(
                                                        "v-icon",
                                                        _vm._g(
                                                          _vm._b(
                                                            {
                                                              staticStyle: {
                                                                "pointer-events":
                                                                  "auto",
                                                              },
                                                              on: {
                                                                click:
                                                                  _vm.copyEmail,
                                                              },
                                                            },
                                                            "v-icon",
                                                            attrs,
                                                            false
                                                          ),
                                                          on
                                                        ),
                                                        [
                                                          _vm._v(
                                                            " " +
                                                              _vm._s(
                                                                _vm.icons
                                                                  .mdiContentCopy
                                                              ) +
                                                              " "
                                                          ),
                                                        ]
                                                      ),
                                                    ]
                                                  },
                                                },
                                              ],
                                              null,
                                              true
                                            ),
                                          },
                                          [
                                            _c("span", [
                                              _vm._v(
                                                _vm._s(
                                                  _vm.$t("copyEmailAddress")
                                                )
                                              ),
                                            ]),
                                          ]
                                        ),
                                      ]
                                    },
                                    proxy: true,
                                  },
                                ],
                                null,
                                true
                              ),
                            }),
                            _c("v-divider", { staticClass: "mb-4" }),
                            _c(
                              "v-btn",
                              {
                                staticClass: "mb-2",
                                attrs: {
                                  text: "",
                                  small: "",
                                  color: "primary",
                                },
                                on: {
                                  click: function ($event) {
                                    _vm.showEmailFields = !_vm.showEmailFields
                                  },
                                },
                              },
                              [
                                _vm._v(
                                  " " +
                                    _vm._s(
                                      _vm.$t(
                                        "pages.settings.users.editDialog.changeEmail"
                                      )
                                    ) +
                                    " "
                                ),
                              ]
                            ),
                            _vm.showEmailFields
                              ? [
                                  _c("validation-provider", {
                                    attrs: {
                                      name: "newEmail",
                                      rules: "required|email",
                                    },
                                    scopedSlots: _vm._u(
                                      [
                                        {
                                          key: "default",
                                          fn: function ({ errors }) {
                                            return [
                                              _c("v-text-field", {
                                                staticClass: "mb-2",
                                                attrs: {
                                                  type: "email",
                                                  outlined: "",
                                                  "error-messages": errors,
                                                  autocomplete: "off",
                                                  name: "editUserNewEmail",
                                                  label:
                                                    _vm.$t("fields.newEmail"),
                                                },
                                                model: {
                                                  value: _vm.form.newEmail,
                                                  callback: function ($$v) {
                                                    _vm.$set(
                                                      _vm.form,
                                                      "newEmail",
                                                      $$v
                                                    )
                                                  },
                                                  expression: "form.newEmail",
                                                },
                                              }),
                                            ]
                                          },
                                        },
                                      ],
                                      null,
                                      true
                                    ),
                                  }),
                                  _c("validation-provider", {
                                    attrs: {
                                      name: "confirmEmail",
                                      rules: "required|confirmed:newEmail",
                                    },
                                    scopedSlots: _vm._u(
                                      [
                                        {
                                          key: "default",
                                          fn: function ({ errors }) {
                                            return [
                                              _c("v-text-field", {
                                                staticClass: "mb-2",
                                                attrs: {
                                                  type: "email",
                                                  outlined: "",
                                                  "error-messages": errors,
                                                  autocomplete: "off",
                                                  name: "editUserConfirmEmail",
                                                  label: _vm.$t(
                                                    "fields.confirmNewEmail"
                                                  ),
                                                },
                                                model: {
                                                  value: _vm.form.confirmEmail,
                                                  callback: function ($$v) {
                                                    _vm.$set(
                                                      _vm.form,
                                                      "confirmEmail",
                                                      $$v
                                                    )
                                                  },
                                                  expression:
                                                    "form.confirmEmail",
                                                },
                                              }),
                                            ]
                                          },
                                        },
                                      ],
                                      null,
                                      true
                                    ),
                                  }),
                                ]
                              : _vm._e(),
                            _c("v-divider", { staticClass: "my-4" }),
                            _c(
                              "v-btn",
                              {
                                staticClass: "mb-2",
                                attrs: {
                                  text: "",
                                  small: "",
                                  color: "primary",
                                },
                                on: {
                                  click: function ($event) {
                                    _vm.showPasswordFields =
                                      !_vm.showPasswordFields
                                  },
                                },
                              },
                              [
                                _vm._v(
                                  " " +
                                    _vm._s(
                                      _vm.$t(
                                        "pages.settings.users.editDialog.changePassword"
                                      )
                                    ) +
                                    " "
                                ),
                              ]
                            ),
                            _vm.showPasswordFields
                              ? [
                                  _c("validation-provider", {
                                    attrs: {
                                      name: "newPassword",
                                      rules: "required|min:6",
                                    },
                                    scopedSlots: _vm._u(
                                      [
                                        {
                                          key: "default",
                                          fn: function ({ errors }) {
                                            return [
                                              _c("v-text-field", {
                                                staticClass: "mb-2",
                                                attrs: {
                                                  type: "password",
                                                  outlined: "",
                                                  "error-messages": errors,
                                                  autocomplete: "new-password",
                                                  name: "editUserNewPassword",
                                                  label:
                                                    _vm.$t(
                                                      "fields.newPassword"
                                                    ),
                                                },
                                                model: {
                                                  value: _vm.form.newPassword,
                                                  callback: function ($$v) {
                                                    _vm.$set(
                                                      _vm.form,
                                                      "newPassword",
                                                      $$v
                                                    )
                                                  },
                                                  expression:
                                                    "form.newPassword",
                                                },
                                              }),
                                            ]
                                          },
                                        },
                                      ],
                                      null,
                                      true
                                    ),
                                  }),
                                  _c("validation-provider", {
                                    attrs: {
                                      name: "confirmPassword",
                                      rules: "required|confirmed:newPassword",
                                    },
                                    scopedSlots: _vm._u(
                                      [
                                        {
                                          key: "default",
                                          fn: function ({ errors }) {
                                            return [
                                              _c("v-text-field", {
                                                attrs: {
                                                  outlined: "",
                                                  type: "password",
                                                  "error-messages": errors,
                                                  autocomplete: "new-password",
                                                  name: "editUserConfirmPassword",
                                                  label: _vm.$t(
                                                    "fields.confirmNewPassword"
                                                  ),
                                                },
                                                model: {
                                                  value:
                                                    _vm.form.confirmPassword,
                                                  callback: function ($$v) {
                                                    _vm.$set(
                                                      _vm.form,
                                                      "confirmPassword",
                                                      $$v
                                                    )
                                                  },
                                                  expression:
                                                    "form.confirmPassword",
                                                },
                                              }),
                                            ]
                                          },
                                        },
                                      ],
                                      null,
                                      true
                                    ),
                                  }),
                                ]
                              : _vm._e(),
                          ],
                          2
                        )
                      : _vm._e(),
                    _c("v-divider", { staticClass: "w-100" }),
                    _c(
                      "v-card-actions",
                      { staticClass: "justify-end" },
                      [
                        _c(
                          "v-btn",
                          {
                            attrs: {
                              text: "",
                              color: "error",
                              disabled: _vm.loading,
                            },
                            on: { click: _vm.close },
                          },
                          [_vm._v(" " + _vm._s(_vm.$t("cancel")) + " ")]
                        ),
                        _c(
                          "v-btn",
                          {
                            attrs: {
                              color: "primary",
                              elevation: 0,
                              disabled: _vm.loading || invalid,
                            },
                            on: { click: _vm.save },
                          },
                          [_vm._v(" " + _vm._s(_vm.$t("save")) + " ")]
                        ),
                      ],
                      1
                    ),
                  ]
                },
              },
            ]),
          }),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }